"use client";

import { useEffect } from "react";

/** Reads the rest of a short server-paged list as soon as its first page is in. */
export function useReadToEnd(query: {
	fetchNextPage: () => unknown;
	hasNextPage: boolean;
	isFetchingNextPage: boolean;
}) {
	const { fetchNextPage, hasNextPage, isFetchingNextPage } = query;
	useEffect(() => {
		if (hasNextPage && !isFetchingNextPage) void fetchNextPage();
	}, [hasNextPage, isFetchingNextPage, fetchNextPage]);
}
